import { useRef } from 'react';

import { type EndStateConfig, ExperiencePerformanceTypes, ExperienceTypes } from '../core';
import { StreamingUFOExperience } from '../core/experience/StreamingUFOExperience';

export const useUFOStreamingExperience = (id: string, component: string) => {
	const ref = useRef<StreamingUFOExperience>(
		new StreamingUFOExperience(id, {
			type: ExperienceTypes.Experience,
			performanceType: ExperiencePerformanceTypes.InlineResult,
			platform: { component },
		}),
	);

	const start = () => {
		ref.current.start();
	};

	const success = (config?: EndStateConfig) => {
		ref.current.success(config);
	};

	const failure = (config?: EndStateConfig) => {
		ref.current.failure(config);
	};

	const abort = (config?: EndStateConfig) => {
		ref.current.abort(config);
	};

	const startConnectionAttempt = () => {
		ref.current.startConnectionAttempt();
	};

	const successConnectionEstablished = () => {
		ref.current.connectionEstablished();
	};

	const reportTTFB = () => {
		ref.current.reportTTFB();
	};

	const reportRTT = (chunkIndex: number) => {
		ref.current.reportRTT(chunkIndex);
	};

	return {
		startConnectionAttempt,
		successConnectionEstablished,
		reportTTFB,
		reportRTT,
		start,
		success,
		failure,
		abort,
	};
};
